export const REPORT_REASONS = ['wrong_answer', 'unclear', 'typo', 'other'] as const;

export type ReportReason = (typeof REPORT_REASONS)[number];

export const REPORT_STATUSES = ['open', 'resolved'] as const;

export type ReportStatus = (typeof REPORT_STATUSES)[number];

export const REPORT_NOTE_LIMIT = 500;
